(function () {
  try {
    /* main variables */
    var debug = 0;
    var variation_name = "cre-t-9";

    /* all Pure helper functions */

    function waitForElement(selector, trigger, delayInterval = 50, delayTimeout = 15000) {
      var interval = setInterval(function () {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
          clearInterval(interval);
          trigger();
        }
      }, delayInterval);

      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    function addClass(selector, className) {
      var element = typeof selector === "string" ? document.querySelector(selector) : selector;
      if (!element) return;
      element.classList.add(className);
    }

    function removeClass(selector, className) {
      var element = typeof selector === "string" ? document.querySelector(selector) : selector;
      if (!element) return;
      element.classList.remove(className);
    }

    function live(selector, event, callback, context) {
      if (typeof callback !== "function") return;
      context = context || document;

      context.addEventListener(event, function (e) {
        var el = e.target.closest(selector);
        if (el && context.contains(el)) {
          callback.call(el, e);
        }
      });
    }

    function insertAfter(selector, html) {
      var element = typeof selector === "string" ? document.querySelector(selector) : selector;
      if (!element) return;

      if (typeof html === "string") {
        element.insertAdjacentHTML("afterend", html);
      } else if (html && html.nodeType === 1) {
        element.insertAdjacentElement("afterend", html);
      }
    }

    function fetchDetect(dynamicKey, searchString, callback) {
      if (window[dynamicKey]) return;

      var performanceObserver = new PerformanceObserver(function (list) {
        var entries = list.getEntries();

        entries.forEach(function (entry) {
          if (
            entry.entryType === "resource" &&
            entry.initiatorType === "fetch" &&
            entry.name.includes(searchString)
          ) {
            callback(entry);
          }
        });
      });

      performanceObserver.observe({ entryTypes: ["resource"] });
      window[dynamicKey] = true;
    }



    function extractNumber(currencyString) {
  const cleanedString = currencyString.replace(/[^\d.]/g, '');

  return parseFloat(cleanedString);
}

    var G500_COLLECTION = "products-eligible-for-500g-volume-discount-test";
    var STD_COLLECTION = "products-eligible-for-volume-discounts";

    function fetchCollectionProductIds(handle) {
      function fetchPage(page) {
        return fetch("/collections/" + handle + "/products.json?limit=250&page=" + page)
          .then(function (res) { return res.ok ? res.json() : { products: [] }; })
          .then(function (data) {
            var products = data.products || [];
            var ids = [];
            products.forEach(function (p) {
              ids.push(String(p.id));
              if (p.handle) ids.push(p.handle);
            });
            if (products.length === 250) {
              return fetchPage(page + 1).then(function (rest) { return ids.concat(rest); });
            }
            return ids;
          })
          .catch(function () { return []; });
      }
      return fetchPage(1);
    }

    function toIdSet(ids) {
      var idSet = {};
      ids.forEach(function (id) { idSet[id] = true; });
      return idSet;
    }

    // Cached on window; resolves to { g500, std, all }.
    function getEligibleIdSets() {
      if (!window.creT9EligibleIdSetsPromise) {
        window.creT9EligibleIdSetsPromise = Promise.all([
          fetchCollectionProductIds(G500_COLLECTION),
          fetchCollectionProductIds(STD_COLLECTION)
        ]).then(function (results) {
          return {
            g500: toIdSet(results[0]),
            std: toIdSet(results[1]),
            all: toIdSet(results[0].concat(results[1]))
          };
        });
      }
      return window.creT9EligibleIdSetsPromise;
    }

    // Identifiers for a cart line: "tt" attribute and product handle from href.
    function getCartItemIdentifiers(item) {
      var identifiers = [];
      var nameEl = item.querySelector(".cart-item__name");
      if (!nameEl) return identifiers;

      var productId = nameEl.getAttribute("tt");
      if (productId) identifiers.push(productId);

      var href = nameEl.getAttribute("href") || "";
      var match = href.match(/\/products\/([^/?#]+)/);
      if (match) identifiers.push(match[1]);

      return identifiers;
    }

    function isCartItemEligible(item, eligibleIds) {
      return getCartItemIdentifiers(item).some(function (identifier) {
        return !!eligibleIds[identifier];
      });
    }

    // Sum quantity of all eligible cart lines.
    function computeCartTotalQuantity(eligibleIds) {
      var total = 0;
      document.querySelectorAll(".cart-item").forEach(function (item) {
        if (eligibleIds && !isCartItemEligible(item, eligibleIds)) return;

        var qtyEl = item.querySelector(".quantity__input");
        if (!qtyEl) return;

        total += parseInt(qtyEl.value, 10) || 0;
      });
      return total;
    }

    // Variant size in grams from the "Size" option, or null.
    function getCartItemGrams(item) {
      var sizeEl = item.querySelector(".product-option dd");
      var match = sizeEl && sizeEl.textContent.match(/([\d.]+)\s*(kg|g)\b/i);
      if (!match) return null;
      return parseFloat(match[1]) * (match[2].toLowerCase() === "kg" ? 1000 : 1);
    }

    // Tier set for a line: one collection wins; if in both, size decides (900g+ = std).
    function getCartItemScope(item, sets) {
      var inG500 = isCartItemEligible(item, sets.g500);
      var inStd = isCartItemEligible(item, sets.std);
      if (inG500 && !inStd) return "g500";
      if (inStd && !inG500) return "std";

      var grams = getCartItemGrams(item);
      if (grams === null) return "both";
      return grams >= 900 ? "std" : "g500";
    }

    function getCartItemKey(item, sets) {
      var ids = getCartItemIdentifiers(item);
      return (ids[ids.length - 1] || "") + "|" + getCartItemScope(item, sets);
    }

    // Tiers count per product: same product and tier set, across its lines.
    // Returns { key: { qty, scope } } for eligible lines.
    function computeGroupQuantities(sets) {
      var groups = {};
      document.querySelectorAll(".cart-item").forEach(function (item) {
        if (!isCartItemEligible(item, sets.all)) return;

        var qtyEl = item.querySelector(".quantity__input");
        var qty = qtyEl ? parseInt(qtyEl.value, 10) || 0 : 0;
        var key = getCartItemKey(item, sets);

        groups[key] = groups[key] || { qty: 0, scope: getCartItemScope(item, sets) };
        groups[key].qty += qty;
      });
      return groups;
    }

    function getGroupTierInfo(price, group) {
      return getTierInfo(price, group.qty, group.qty, group.scope);
    }

    /* Variation functions */

    function isUkVisitor() {
      var countryEl = document.querySelector(".header__localization-button .currency-country");
      var languageEl = document.querySelector(".localization-selector .value");

      var isGB = !!countryEl && countryEl.textContent.trim() === "GB";
      var isEN = !!languageEl && languageEl.textContent.trim() === "EN";

      return isGB && isEN;
    }

    function isCartPage() {
      return /^\/cart\/?$/.test(window.location.pathname);
    }

    function replaceGbpSymbol(priceWrapper) {
      var priceItems = priceWrapper.querySelectorAll(".price .price-item");

      priceItems.forEach(function (item) {
        if (item.textContent.indexOf("GBP") === -1) return;
        item.textContent = item.textContent.replace(/GBP\s*/g, "£").trim();
      });
    }

    function addFreeShippingNote(priceWrapper) {
      if (priceWrapper.querySelector(".cre-t-9-shipping-note")) return;

      var taxEl = priceWrapper.querySelector(".product__tax");
      if (!taxEl) return;

      var noteHtml = '<div class="cre-t-9-shipping-note">Free shipping on orders £75+</div>';
      insertAfter(taxEl, noteHtml);
    }

    function inlineTaxWithPrice(priceWrapper) {
      addClass(priceWrapper, "cre-t-9-inline-tax");

      var priceEl = priceWrapper.querySelector(".price");
      var taxEl = priceWrapper.querySelector(".product__tax");
      if (!priceEl || !taxEl) return;
      if (taxEl.textContent.indexOf("Tax included") === -1) return;

      addClass(document.body, "cre-t-9-tax");

      if (priceWrapper.querySelector(".cre-t-9-tax-text")) return;

      var taxHtml = '<span class="cre-t-9-tax-text">Tax included.</span>';
      insertAfter(priceEl, taxHtml);
    }

    function hideExtraSections() {
      addClass(document.body, variation_name + "-uk");
    }

    var STD_TIERS = [
      { qty: 6, pct: 5 },
      { qty: 12, pct: 10 },
      { qty: 18, pct: 15 },
      { qty: 30, pct: 20 }
    ];

    var G500_TIERS = [
      { qty: 12, pct: 5 },
      { qty: 24, pct: 10 },
      { qty: 36, pct: 15 },
      { qty: 60, pct: 20 }
    ];

    function evaluateTiers(tiers, quantity) {
      var unlocked = null;
      var next = null;
      tiers.forEach(function (tier) {
        if (quantity >= tier.qty) {
          unlocked = tier;
        } else if (!next) {
          next = tier;
        }
      });
      return { pct: unlocked ? unlocked.pct : 0, next: next };
    }

    //freeShipping is merged into the unlocked line.
    function buildTierText(result, freeShipping) {
      var unlocked = freeShipping ? "Free Shipping" : "";
      if (result.pct) {
        unlocked += (unlocked ? " and " : "") + result.pct + "% off";
      }
      var nextText = result.next
        ? "Order " + result.next.qty + " to get " + result.next.pct + "% off your order."
        : "";

      if (!result.pct) {
        return (unlocked ? "You’ve unlocked " + unlocked + "! " : "") + '<span class="cre-t-9-discount-msg">' + nextText + '</span>';
      }
      var shippingText = freeShipping ? "Free Shipping" : "";
      var discountText = (shippingText ? " and " : "") + result.pct + "% off";
      return '<span class="cre-t-9-discount-msg">Congratulations, </span>You’ve unlocked ' + shippingText + '<span class="cre-t-9-discount-msg">' + discountText + '</span>!' + (nextText ? ' <span class="cre-t-9-discount-msg">' + nextText + '</span>' : "");
    }




    // Better discount wins (tie: more items, then std). `scope` forces one set;
    // free shipping is judged on the whole-cart price.
    function getTierInfo(price, qtyStd, qty500, scope) {
      var std = evaluateTiers(STD_TIERS, qtyStd);
      var g500 = evaluateTiers(G500_TIERS, qty500);
      var use500 = scope === "g500" ||
        (scope !== "std" && (g500.pct > std.pct || (g500.pct === std.pct && qty500 > qtyStd)));
      var url = "/collections/" + (use500 ? G500_COLLECTION : STD_COLLECTION);

      if (price < 75) {
        return { message: '<span class="cre-t-9-shipping-msg">Spend £75 and get Free Shipping!</span>', isTopTier: false, url: url, pct: use500 ? g500.pct : std.pct };
      }
      if (use500) {
        return {
          message: buildTierText(g500, true),
          isTopTier: !g500.next,
          url: url,
          pct: g500.pct
        };
      }
      return {
        message: buildTierText(std, true),
        isTopTier: !std.next,
        url: url,
        pct: std.pct
      };
    }

    function showFakePriceWhileLoading(priceWrapper) {
      removeFakePrice(priceWrapper);

      var fakePrice = priceWrapper.cloneNode(true);
      fakePrice.removeAttribute("id");
      fakePrice.setAttribute("aria-hidden", "true");
      fakePrice.classList.remove("cre-t-9-price-loading");
      fakePrice.classList.add("cre-t-9-price-fake");

      priceWrapper.insertAdjacentElement("afterend", fakePrice);
      addClass(priceWrapper, "cre-t-9-price-loading");
    }

    function removeFakePrice(priceWrapper) {
      var parent = priceWrapper.parentElement;
      if (parent) {
        parent.querySelectorAll(".cre-t-9-price-fake").forEach(function (fakePrice) {
          fakePrice.remove();
        });
      }

      removeClass(priceWrapper, "cre-t-9-price-loading");
    }

    function hidePriceWrapperOnVariantSwitch() {
      if(!window.creT9eventAdded) {
        window.creT9eventAdded = true;
      live(".product-form__controls-group .size_value_block", "click", function () {
        if (!isUkVisitor()) return;

        var input = this.control;
        if (input && input.checked) return;

        document.querySelectorAll(".price-wrapper").forEach(function (priceWrapper) {
          showFakePriceWhileLoading(priceWrapper);
        });
      });
    }
    }

    function init() {
      if (!isUkVisitor()) return;
      document.querySelectorAll(".price-wrapper").forEach(function (priceWrapper) {
        replaceGbpSymbol(priceWrapper);
        inlineTaxWithPrice(priceWrapper);
        addFreeShippingNote(priceWrapper);
      });
      hideExtraSections();
    }

  



   function cartPageChanges(){
    if (!isCartPage()) return;
    if (!isUkVisitor()) return;
     waitForElement(".accordion_est", function () {

      
      

      document.querySelector('.accordion_est').classList.add('active');
       waitForElement(".accordion_est +.panel_est", function () {
        setTimeout(function () {
          document.querySelector('.panel_est').style.display = 'block';
        }, 2000);
       
    }, 50, 15000);
    }, 50, 15000);

    function ensureCartItemUpsellNote(cartItem) {
      var note = cartItem.querySelector(".saso-cart-item-upsell-notes");
      if (note) return note;

      var anchorEl =
        cartItem.querySelector(".saso-cart-item-discount-notes") ||
        cartItem.querySelector(".cart-item__details") ||
        cartItem;

      insertAfter(anchorEl, '<span class="saso-cart-item-upsell-notes cre-t-9-fallback-note"></span>');
      return cartItem.querySelector(".saso-cart-item-upsell-notes");
    }

    // Trigger on .cart-item (Saso's <a> disappears at the top tier).
    waitForElement(".cart-item", function () {
      getEligibleIdSets().then(function (sets) {
      var eligibleIds = sets.all;
      const forceInsertion = setInterval(function () {
      const cartItems = document.querySelectorAll(".cart-item");
      if(cartItems.length > 0) {
        const price = document.querySelector(".totals .transcy-money")?.textContent;
        const numericPrice = extractNumber(price);
        const groups = computeGroupQuantities(sets);

        cartItems.forEach(function (cartItem) {
          if (!isCartItemEligible(cartItem, eligibleIds)) return;

          // message per line's own tier set
          var tierInfo = getGroupTierInfo(numericPrice, groups[getCartItemKey(cartItem, sets)]);
          var tierMessage = tierInfo.message;
          var isTopTier = tierInfo.isTopTier;

          var note = ensureCartItemUpsellNote(cartItem);
          if (!note) return;
          note.style.display = "";

          var links = note.querySelectorAll("a");
          if (links.length === 0) {
            var fallbackLink = document.createElement("a");
            note.appendChild(fallbackLink);
            links = [fallbackLink];
          }

          links.forEach(function (link) {
            link.innerHTML = tierMessage;
            link.setAttribute("href", tierInfo.url);
            removeClass(link, "cre-t-9-tier-plain");
          });

          if (numericPrice >= 75) {
            var discountNote = cartItem.querySelector('.saso-cart-item-discount-notes');
            if (discountNote) discountNote.innerHTML = '<span class="cre-t-9-discount-msg">You\'ve reached a discount! :)</span>';
          }
        });
       }
      },500)

      setTimeout(function () {
        clearInterval(forceInsertion);
      }, 5000);
      });

    }, 50, 15000);
   }


   function miniCartChanges(){

    if (!isUkVisitor()) return;


     var MINICART_SUBTOTAL_SELECTOR = ".totals__subtotal-value .transcy-money";
     var MINICART_FOOTER_SELECTOR = ".cart-drawer__footer";
     var MINICART_WRAPPER_CLASS = "cre-t-09-minicart";

     function ensureMinicartBar() {
       var footer = document.querySelector(MINICART_FOOTER_SELECTOR);
       if (!footer || !footer.parentElement) return null;

       var existingWrapper = footer.parentElement.querySelector("." + MINICART_WRAPPER_CLASS);
       if (existingWrapper) return existingWrapper;

       var wrapperHtml =
         '<div class="' + MINICART_WRAPPER_CLASS + '">' +
           '<a href="/collections/' + STD_COLLECTION + '" class=""></a>' +
         '</div>';

       insertAfter(footer, wrapperHtml);

       return footer.parentElement.querySelector("." + MINICART_WRAPPER_CLASS);
     }

     function updateMinicartBar(amount, sets) {
       // one bar for the cart: show the product with the best discount (tie: most items)
       var groups = computeGroupQuantities(sets);
       var tierInfo = getTierInfo(amount, 0, 0);
       var bestQty = -1;
       Object.keys(groups).forEach(function (key) {
         var info = getGroupTierInfo(amount, groups[key]);
         if (info.pct > tierInfo.pct || (info.pct === tierInfo.pct && groups[key].qty > bestQty)) {
           tierInfo = info;
           bestQty = groups[key].qty;
         }
       });
       var tierText = tierInfo.message;
       var isTopTier = tierInfo.isTopTier;

       var wrapper = ensureMinicartBar();
       if (!wrapper) return;

       var link = wrapper.querySelector("a");
       if (link) {
         link.innerHTML = tierText;
         link.setAttribute("href", tierInfo.url);
         removeClass(link, "cre-t-9-tier-plain");
       }

       wrapper.style.display = "";
     }

     function readMinicartSubtotalAndUpdate() {
       var subtotalEl = document.querySelector(MINICART_SUBTOTAL_SELECTOR);
       if (!subtotalEl) return;

       var amount = extractNumber(subtotalEl.textContent || "");
       if (isNaN(amount)) return;

       getEligibleIdSets().then(function (sets) {
         updateMinicartBar(amount, sets);
       });
     }

     function pollMinicartUntilSettled(maxTime, interval) {
       var elapsed = 0;
       var lastAmount = null;
       var stableReads = 0;

       var poll = setInterval(function () {
         var subtotalEl = document.querySelector(MINICART_SUBTOTAL_SELECTOR);

         if (subtotalEl) {
           var amount = extractNumber(subtotalEl.textContent || "");

           if (!isNaN(amount)) {
             if (amount === lastAmount) {
               stableReads++;
             } else {
               stableReads = 0;
               lastAmount = amount;
             }

             // stable reads = drawer settled
             if (stableReads >= 2) {
               clearInterval(poll);
               getEligibleIdSets().then(function (sets) {
                 updateMinicartBar(amount, sets);
               });
               return;
             }
           }
         }

         elapsed += interval;
         if (elapsed >= maxTime) {
           clearInterval(poll);
           readMinicartSubtotalAndUpdate(); // last-ditch read
         }
       }, interval);
     }

     // cart already has items on load
     waitForElement(MINICART_SUBTOTAL_SELECTOR, function () {
       if (!isUkVisitor()) return;
       pollMinicartUntilSettled(2000, 100);
     }, 50, 15000);

     // item added/updated later
     fetchDetect("creT9MinicartFetchObserverAdded", "/cart", function () {
       if (!isUkVisitor()) return;
       pollMinicartUntilSettled(2000, 100);
     });
   }




    // site-wide marker on every page; UK class once the visitor's locale is known
    waitForElement("body", function () {
      addClass(document.body, variation_name);
    });
    waitForElement(".header__localization-button .currency-country", function () {
      if (isUkVisitor()) hideExtraSections();
    });

    setTimeout(function(){
       cartPageChanges();
    },4000);
    
    waitForElement(".price-wrapper", init, 50, 15000);
    hidePriceWrapperOnVariantSwitch();
    fetchDetect("creT9FetchObserverAdded", "/products/", function () {
      waitForElement(".price-wrapper", function () {
        init();
        document.querySelectorAll(".price-wrapper").forEach(function (priceWrapper) {
          removeFakePrice(priceWrapper);
        });
      }, 50, 15000);
    });

    waitForElement('.totals__subtotal-value .transcy-money',function(){
      miniCartChanges();
    },50,15000);
   
     miniCartChanges();



  } catch (e) {
    if (debug) console.log(e, "error in Test " + variation_name);
  }
})();